module.exports = __webpack_public_path__ + "img/help.dea131fa.svg";